<template>
  <RYRichTextEditor
    v-if="$store.getters.newRtf"
    ref="RYRichTextEditor"
    @change="change"
    :disabled="disabled"
    :placeholder="placeholder"
    :heightMin="heightMin"
    :heightMax="heightMax"
    :content.sync="currentValue"
    :installBtns="installBtns"
    :isSimpleToolBar="isSimpleToolBar"
    :showQuickBtn="showQuickBtn"
    :charCounterMax="charCounterMax"
  ></RYRichTextEditor>
  <quill-editor
    v-else
    ref="QuillEditor"
    v-model="currentValue"
    @change="change"
    :disabled="disabled"
    :options="editorOption">
  </quill-editor>
</template>

<script>
  import RYRichTextEditor from "./RYRichTextEditor";
  export default {
    name: 'ry-quill-editor',
    props: {
      content: String,
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: ''
      },
      heightMin: {
        type: Number,
        default: 300
      },
      heightMax: {
        type: Number,
        default: 800
      },
      isSimpleToolBar: {
        type: Boolean,
        default: true
      },
      installBtns: {
        type: Array,
        default: () => []
      },
      showQuickBtn: {
        type: Boolean,
        default: true
      },
      // 最大字数限制
      charCounterMax: {
        type: Number,
        default: -1
      },
    },
    components: {
      RYRichTextEditor
    },
    data () {
      const that = this
      return {
        currentValue: this.content,
        editorOption: {
          placeholder: this.placeholder,
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                [
                  'blockquote'
                ],
                [
                  { 'color': [] },
                  { 'background': [] }
                ],
                [{ 'align': [] }],
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['link', 'image']
              ],
              handlers: {
                image () {
                  const range = this.quill.getSelection()
                  that.fileInputChangeCallback = (url) => {
                    if (range.length) {
                      this.quill.deleteText(range.index, range.length)
                    }
                    this.quill.insertEmbed(range.index, 'image', url)
                    this.quill.setSelection(range.index + 1)
                    that.fileInputEle.value = ''
                  }
                  that.fileInputEle.click()
                }
              }
            }
          }
        },
        fileInputEle: null,
        fileInputChangeCallback: null
      }
    },
    created () {
      this.fileInputEle = document.createElement('input')
      this.fileInputEle.setAttribute('type', 'file')
      this.fileInputEle.setAttribute('accept', 'image/jpeg,image/jpg,image/png')
      this.fileInputEle.onchange = this.quillUploadImage
    },
    methods: {
      // 富文本编辑框上传图片
      quillUploadImage (e) {
        const loading = this.$toast.loading({
          message: '上传中...'
        })
        this.$RyFs.upload(e.target.files)
          .then(urlList => urlList[0])
          .then(url => {
            this.fileInputChangeCallback(url)
          })
          .catch(console.error)
          .finally(() => {
            loading.clear()
          })
      },

      change () {
        this.$emit('update:content', this.currentValue)
        this.$emit('change')
      },
      focus() {
        this.$nextTick(() => {
          if (this.$refs.QuillEditor) {
            this.$refs.QuillEditor.quill.focus()
          }
        })
      }
    }
  }
</script>

